import CallMadeIcon from "@mui/icons-material/CallMade";
import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { MY_PERF_SCROLL_LIST_PB } from "../../Dashboard/layouts";

const PATIENTS_READY_BLUE = "#1F6AA5";
const EXPLORE_ORANGE = "#D96B04";

const headerCellSx = {
  border: "none",
  borderBottom: "1px solid #E8E8E8",
  bgcolor: "#FFFFFF",
  color: "#9AA0A6",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "uppercase",
  py: 1.25,
  whiteSpace: "nowrap",
};

const bodyCellSx = {
  border: "none",
  borderBottom: "1px solid #E8E8E8",
  bgcolor: "#FFFFFF",
  fontSize: 13,
  py: 1.75,
  verticalAlign: "middle",
};

function TableSkeleton() {
  return (
    <Stack spacing={1.2} sx={{ py: 1, pb: MY_PERF_SCROLL_LIST_PB }}>
      {Array.from({ length: 5 }).map((_, idx) => (
        <Skeleton key={idx} variant="rounded" height={28} />
      ))}
    </Stack>
  );
}

export default function TyvasoDpiDosageNotificationCard({
  title = "80 mcg Transition Opportunity: 64 mcg >6 Month",
  rows = [],
  isLoading = false,
  isError = false,
  onExplore,
}) {
  const hasRows = Array.isArray(rows) && rows.length > 0;

  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "8px",
        border: "0.5px solid #F0F0F0",
        boxShadow: "1px 4px 4px 0px #00000008",
      }}
    >
      <CardContent
        sx={{
          p: 3,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            fontSize: 14,
            lineHeight: 1.3,
            color: "#1A1A1A",
          }}
        >
          {title}
        </Typography>

        {isLoading ? (
          <TableSkeleton />
        ) : (
          <TableContainer
            sx={{
              flex: "1 1 0",
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              pr: 0.5,
              width: "100%",
            }}
          >
            {!hasRows ? (
              <Box
                sx={{
                  minHeight: 120,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography sx={{ color: "#718096", fontSize: 14 }}>
                  {isError
                    ? "Unable to load dosage notifications"
                    : "No alerts found"}
                </Typography>
              </Box>
            ) : (
              <Box sx={{ pb: MY_PERF_SCROLL_LIST_PB }}>
                <Table
                  stickyHeader
                  size="small"
                  sx={{ tableLayout: "fixed", width: "100%" }}
                >
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          ...headerCellSx,
                          textAlign: "left",
                          width: "52%",
                        }}
                      >
                        Account Name
                      </TableCell>
                      <TableCell
                        sx={{
                          ...headerCellSx,
                          textAlign: "center",
                          width: "28%",
                        }}
                      >
                        Patients Ready
                      </TableCell>
                      <TableCell
                        sx={{
                          ...headerCellSx,
                          textAlign: "right",
                          width: "20%",
                        }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, idx) => (
                      <TableRow key={row.id ?? `dpi-notify-${idx}`}>
                        <TableCell
                          sx={{
                            ...bodyCellSx,
                            fontWeight: 700,
                            color: "#1A1A1A",
                            textTransform: "uppercase",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                          }}
                        >
                          {row.accountName || "—"}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...bodyCellSx,
                            textAlign: "center",
                            fontWeight: 700,
                            fontSize: 16,
                            color: PATIENTS_READY_BLUE,
                          }}
                        >
                          {row.patientsReady ?? "—"}
                        </TableCell>
                        <TableCell sx={{ ...bodyCellSx, textAlign: "right" }}>
                          {typeof onExplore === "function" ? (
                            <Button
                              variant="text"
                              size="small"
                              onClick={() => onExplore(row)}
                              sx={{
                                textTransform: "none",
                                fontSize: 13,
                                fontWeight: 600,
                                color: EXPLORE_ORANGE,
                                minWidth: "auto",
                                p: 0,
                              }}
                            >
                              Explore
                            </Button>
                          ) : null}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            )}
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}
